import React from 'react'
import "./index.css";
import { PaperUpload } from 'react-iconly';

const SubirContainer = ({
    dragProps,
    isDragging,
    onImageUpload,
}) => {
    return (
        <div
            className={`upload-container ${isDragging ? "upload-drag" : ""}`}
            {...dragProps}
            onClick={onImageUpload}
        >
            <p>
                <PaperUpload set="broken" size={40} primaryColor="blueviolet" />
            </p>
            <p className="mb-1">Haga clic o arrastre el archivo a esta área para subir</p>
            <p >Soporte para una sola carga o carga masiva.</p>
        </div>
    )
}

export default SubirContainer